import React from "react";
import styles from "./ProjectsSection.module.scss";
import Carousel from "../Carousel";
import ProjectCard from "../ProjectCard";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";
import NextArrow from "../NextArrow";
import PrevArrow from "../PrevArrow";

export default function ProjectsSection({ projects }) {
  const projectsSettings = {
    slidesToShow: 3,
    rows: 2,
    slidesToScroll: 1,
    arrows: true,
    infinite: false,
    autoplay: false,
    speed: 500,
    dots: false,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
    className: "product-slider",
    responsive: [
      {
        breakpoint: 1000,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          rows: 1,
        },
      },
      {
        breakpoint: 400,
        settings: {
          slidesToShow: 1,
          rows: 1,
        },
      },
    ],
  };

  const { locale } = useParams();
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <div className={styles.projectsSection}>
      <div className={`${styles.header}`}>
        <h2>{t("home.explore")}</h2>
        <button onClick={() => navigate(`/${locale}/projects`)}>
          {t("home.seeall")}
        </button>
      </div>
      <div className={styles.carouselWrapper}>
        <Carousel sliderSettings={projectsSettings}>
          {projects?.slice(0,5)?.map((project) => {
            return <ProjectCard key={project.id} project={project} />;
          })}
        </Carousel>
      </div>
    </div>
  );
}
